
import api from '@ibkr/clientportal.common/src/api/index';
import iserverApi from '@ibkr/clientportal.common/src/api/iserverApi';
import { httpFailed, httpStatus, httpError } from '@ibkr/clientportal.common/src/js/http'

export const getFolioModels = ({ commit, dispatch, state }, { selectedAcctId }) => {

    iserverApi.getFolioModels({ selectedAcctId })
    .then((res) => {
        commit('SET_FOLIO_MODELS', res.models);
    })
    .catch((err) => {
        httpFailed('get set folio models', commit, err);
    });
}
export const getModelDetails = ({ commit, dispatch, state }, { selectedAcctId, modelName }) => {
    iserverApi.getFolioModel({ selectedAcctId, modelName })
    .then((res) => {
        let model = state.selectedModel;
        if (model.name === res.modelEntry.name) {
            model.positions = res.holdingList || res.targetList;
            model.modelEntry = res.modelEntry;
            dispatch('setSelectedModel', { model });
            if (res?.targetList?.length) {
                let list = res.targetList.map((curr) => {
                    return  { ...curr };
                })
                commit('SET_MODEL_TARGET_LIST', list);
            } else {
                commit('SET_MODEL_TARGET_LIST', []);
            }
        }
    })
    .catch((err) => {
        httpFailed('get model details', commit, err);
    })
}

export const getFolioModelOrders = ({ commit, dispatch, state }, { selectedAcctId, modelName }) => {
    iserverApi.getFolioModelOrders({ selectedAcctId, modelName })
    .then((res) => {
        commit('SET_MODEL_ORDERS_STATUS', res);
    })
    .catch((err) => {
        httpFailed('get model orders', commit, err);
    })
}
export const setSelectedModel = ({ commit, dispatch, state }, { model }) => {
    commit('SET_SELECTED_MODEL', Object.assign({}, model));
}

export const getPerformanceChartData = ({ commit, dispatch, state }, { accId, modelName, benchmarks=[] }) => {
    api.getPerformanceAllPeriods(accId, modelName, benchmarks)
    .then((res) => {
        commit('SET_PERFORMANCE_CHART_DATA', res)
    })
    .catch((err) => {
        httpFailed('get performance chart details', commit, err);
    })
}

export const createUpdateFolioModel = ({ commit, dispatch, state },
    {
        selectedAcctId,
        modelEntry,
        targetList
    }) => {
        iserverApi.createUpdateFolioModel({ selectedAcctId, modelEntry, targetList })
        .then((res) => {
            commit('SET_SAVED_MODEL_REQUEST_STATUS', res);
        })
        .catch((err) => {
            httpFailed('createUpdateFolioModel details', commit, err);
        })
}

export const rebalanceFolioModel = ({ commit, dispatch, state },
    {
        selectedAcctId,
        modelName,
        amount,
        fullDivest
    }) => {
        iserverApi.rebalanceFolioModel({ selectedAcctId, modelName, amount, fullDivest })
        .then((res) => {
            commit('SET_REBALANCE_FOLIO_MODEL', res);
        })
        .catch((err) => {
            httpFailed('rebalanceFolioModel details', commit, err);
        })
}

export const transmitFolioOrders = ({ commit, dispatch, state },
    {
        investDivestRebalanceSetID,
        overrideList,
        waitSeconds
    }) => {
        iserverApi.transmitFolioOrders({ investDivestRebalanceSetID, overrideList, waitSeconds })
        .then((res) => {
            commit('SET_TRANSMIT_ORDER_STATUS', res);
        })
        .catch((err) => {
            httpFailed('transmitFolioOrders details', commit, err);
        })
}
